export type ClientKind = "web" | "extension-chrome" | "extension-firefox";

export const CLIENT_HEADER = "X-UniDeck-Client";

const detect = (): ClientKind => {
  if (!import.meta.env.MANIFEST_VERSION) {
    return "web";
  }
  const browser = (import.meta.env as Record<string, unknown>).BROWSER;
  if (browser === "firefox") {
    return "extension-firefox";
  }
  if (browser === "chrome") {
    return "extension-chrome";
  }
  return typeof navigator !== "undefined" &&
    /Firefox\//.test(navigator.userAgent)
    ? "extension-firefox"
    : "extension-chrome";
};

export const clientKind: ClientKind = detect();

export const isExtension = clientKind !== "web";
